export const SET_MESSAGE: "modal/SET_MESSAGE" = "modal/SET_MESSAGE";
export const CLEAR_MESSAGE: "modal/CLEAR_MESSAGE" = "modal/CLEAR_MESSAGE";
